<template>
  <div>
    <!-- begin current step card -->
    <b-row v-if="currentStep" class="m-0 m-b-10">
      <b-card class="w-100" bg-variant="dark" text-variant="light">
        <b-row>
          <b-col class="d-flex" order="4" cols="6" order-lg="1" lg="1">
            <button
              v-if="selectedSteps.length > 1"
              @click="previousStep"
              class="btn btn-yellow btn-icon btn-circle btn-lg my-auto"
            >
              <i class="fa fa-chevron-left" />
            </button>
          </b-col>
          <b-col
            @click="showStep()"
            style="cursor: pointer"
            order="1"
            cols="12"
            :md="stepColumnSize(currentStep)"
            order-lg="2"
            :lg="stepColumnSize(currentStep)"
          >
            <b-card no-body bg-variant="dark" class="overflow-hidden">
              <b-row no-gutters>
                <b-col class="text-right d-flex">
                  <b-card-img
                    :src="getImage(currentStep.image)"
                    alt="Step image"
                    class="rounded-0 ml-auto my-auto"
                    style="max-width: 100px; max-height: 100px"
                  ></b-card-img>
                </b-col>
                <b-col>
                  <b-card-body>
                    <b-card-text>
                      <p class="m-0">
                        Current step
                        {{
                          selectedSteps.length > 1
                            ? `(${selectedSteps.indexOf(currentStep) + 1}/${
                                selectedSteps.length
                              })`
                            : ''
                        }}
                      </p>
                      <b>
                        {{ $parent.getStoryboard(currentStep.stage).name }}
                        <i class="fa fa-chevron-right" />
                        {{ $parent.getStage(currentStep.stage).name }}
                        <i class="fa fa-chevron-right" />
                      </b>
                      <h1>{{ currentStep.name }}</h1>
                    </b-card-text>
                  </b-card-body>
                </b-col>
              </b-row>
            </b-card>
          </b-col>
          <b-col
            @click="showStep()"
            style="cursor: pointer"
            v-if="currentStep.target"
            order="2"
            cols="12"
            :md="currentStep.plan ? 4 : 5"
            order-lg="3"
            :lg="currentStep.plan ? 3 : 5"
          >
            <b-card no-body bg-variant="dark" class="overflow-hidden">
              <b-card-body>
                <b-card-text>
                  <b>Target outcome</b>
                  <p>{{ currentStep.target }}</p>
                </b-card-text>
              </b-card-body>
            </b-card>
          </b-col>
          <b-col
            @click="showStep()"
            style="cursor: pointer"
            v-if="currentStep.plan"
            order="3"
            cols="12"
            :md="currentStep.target ? 4 : 5"
            order-lg="4"
            :lg="currentStep.target ? 3 : 5"
          >
            <b-card no-body bg-variant="dark" class="overflow-hidden">
              <b-card-body>
                <b-card-text>
                  <b>Things to provide</b>
                  <p>{{ currentStep.plan }}</p>
                </b-card-text>
              </b-card-body>
            </b-card>
          </b-col>
          <b-col class="d-flex" order="5" cols="6" order-lg="5" lg="1">
            <button
              v-if="selectedSteps.length > 1"
              @click="nextStep"
              class="
                btn btn-yellow btn-icon btn-circle btn-lg
                pull-right
                my-auto
                ml-auto
              "
            >
              <i class="fa fa-chevron-right" />
            </button>
          </b-col>
        </b-row>
      </b-card>
    </b-row>
    <!-- end current step card -->
    <!-- begin current step modal -->
    <b-modal
      v-if="currentStep"
      ref="modalStep"
      size="xl"
      centered
      title="Current step"
      hide-footer
    >
      <step-show
        :step="currentStep"
        :stage="$parent.getStage(currentStep.stage)"
        :storyboard="$parent.getStoryboard(currentStep.stage)"
        :scriptItems="scriptItems"
        :modalMode="true"
      />
    </b-modal>
    <!-- end current step modal -->

    <!-- begin tabs -->
    <b-card no-body>
      <b-tabs
        v-model="tabIndex"
        justified
        nav-class="nav-tabs-inverse"
        nav-wrapper-class="nav-tabs-inverse"
      >
        <!-- begin tab -->
        <b-tab @click="navigateTo('space')">
          <template slot="title">
            <span class="d-sm-none">Tab 2</span>
            <span class="d-sm-block d-none">Space</span>
          </template>
        </b-tab>
        <!-- end tab -->
        <!-- begin tab -->
        <b-tab @click="navigateTo('stuff')">
          <template slot="title">
            <span class="d-sm-none">Tab 4</span>
            <span class="d-sm-block d-none">Stuff</span>
          </template>
        </b-tab>
        <!-- end tab -->
        <!-- begin tab -->
        <b-tab @click="navigateTo('staff')">
          <template slot="title">
            <span class="d-sm-none">Tab 3</span>
            <span class="d-sm-block d-none">Staff</span>
          </template>
        </b-tab>
        <!-- end tab -->
        <!-- begin tab -->
        <b-tab @click="navigateTo('service')">
          <template slot="title">
            <span class="d-sm-none">Tab 1</span>
            <span class="d-sm-block d-none">Service</span>
          </template>
        </b-tab>
        <!-- end tab -->
        <!-- begin tab -->
        <b-tab @click="navigateTo('summary')">
          <template slot="title">
            <span class="d-sm-none">Tab 5</span>
            <span class="d-sm-block d-none">Summary</span>
          </template>
        </b-tab>
        <!-- end tab -->

        <!-- begin summary page content -->
        <div v-if="$route.params.type == 'summary'" class="p-20">
          <script-step-summary
            :step="currentStep"
            :scriptItems="scriptItems"
            :categories="categories"
            :confirmStepPlans="confirmStepPlans"
            :getFullItem="getFullItem"
            :returnToSelection="returnToSelection"
          />
        </div>
        <!-- end summary page content -->

        <!-- begin 4S page content -->
        <div v-else class="p-20">
          <!-- begin buttons row -->
          <b-row class="m-b-15">
            <b-col>
              <input-button
                type="button"
                label="Step selection"
                class="btn-dark"
                @click="returnToSelection()"
              />
              <b-button
                class="pull-right"
                :variant="currentStepTypeState ? 'outline-dark' : 'yellow'"
                @click="changeStepTypeState"
              >
                {{
                  currentStepTypeState
                    ? `Unconfirm ${$route.params.type} plans`
                    : `Confirm ${$route.params.type} plans`
                }}
              </b-button>
            </b-col>
          </b-row>
          <!-- end buttons row -->
          <b-row>
            <b-col
              xl="4"
              lg="4"
              md="12"
              sm="12"
              class="rounded bg-light p-b-15 p-t-5 m-b-15"
            >
              <h3>Active area</h3>
              <div class="card-columns" v-if="filteredScriptItems.length">
                <!-- begin scriptitem card -->
                <div
                  v-for="sItem in filteredScriptItems"
                  :key="sItem.id"
                  class="card text-dark bg-yellow text-center"
                >
                  <div
                    class="card-body"
                    v-bind:class="
                      activeScriptItem &&
                      activeScriptItem.id == sItem.id &&
                      activeItem &&
                      sItem.item.id == activeItem.id
                        ? 'bg-dark text-light'
                        : 'bg-yellow'
                    "
                  >
                    <blockquote class="blockquote mb-0">
                      <span>
                        {{ sItem.item.name }}
                        <b-badge
                          :variant="
                            activeScriptItem &&
                            activeScriptItem.id == sItem.id &&
                            activeItem &&
                            sItem.item.id == activeItem.id
                              ? 'light'
                              : 'dark'
                          "
                          >{{ sItem.amount }}</b-badge
                        >
                      </span>
                      <footer class="text-dark-transparent-8 m-t-5">
                        <!--Amount: {{ sItem.amount }} <br/>-->
                        <input-button
                          v-if="
                            activeScriptItem &&
                            activeScriptItem.id == sItem.id &&
                            activeItem &&
                            sItem.item.id == activeItem.id
                          "
                          type="button"
                          label="Selected"
                          @click="setActiveItem(sItem, true)"
                          class="btn-sm btn-yellow mt-1 w-100"
                          disabled
                        />
                        <input-button
                          v-else
                          type="button"
                          label="Select"
                          @click="setActiveItem(sItem, true)"
                          class="btn-sm btn-dark mt-1 w-100"
                        />
                      </footer>
                    </blockquote>
                  </div>
                </div>
                <!-- end scriptitem card -->
              </div>
              <div class="p-5" v-else>
                <p>
                  {{
                    currentStepTypeState
                      ? 'No items required'
                      : 'No active items'
                  }}
                </p>
              </div>
            </b-col>
            <b-col xl="3" lg="3" md="4" sm="12" class="p-l-15 m-b-15">
              <!-- begin active item card -->
              <div v-if="activeItem" class="card">
                <div class="text-center bg-light">
                  <img
                    class="card-img-top"
                    :src="getImage(activeItem.image)"
                    alt="Active item image"
                    style="max-width: 375px"
                  />
                </div>
                <div class="card-body p-b-0 p-t-10">
                  <h4 class="card-title m-b-0">
                    {{ activeItem.name }}
                  </h4>
                  <!--
                            <p v-if="activeItem.description" class="card-text">{{ activeItem.description }}</p>
                            -->
                  <ul class="list-group list-group-flush">
                    <li class="list-group-item">
                      Available:
                      {{ activeItem.amount - checkUsage(activeItem.id) }}
                      {{ activeItem.unit }}
                    </li>
                    <li class="list-group-item">
                      In use: {{ checkUsage(activeItem.id) }}
                      {{ activeItem.unit }}
                    </li>
                    <li class="list-group-item">
                      Unit price:
                      {{
                        activeItem.unitPrice
                          ? activeItem.unitPrice + ' EUR'
                          : '-'
                      }}
                    </li>
                  </ul>
                </div>
                <div class="card-footer p-10 p-b-5">
                  <input-button
                    type="button"
                    label="Unselect"
                    class="btn-dark btn-sm"
                    @click="emptyActiveItem()"
                  />
                  <input-button
                    type="button"
                    label="View details"
                    class="btn-yellow btn-sm pull-right"
                    @click="showItem()"
                  />
                </div>
              </div>
              <!-- end active item card -->
              <!-- begin empty item card -->
              <div v-else class="card" style="min-height: 375px">
                <div class="card-body">
                  <h4 class="card-title text-center">No item selected</h4>
                </div>
              </div>
              <!-- end empty item card -->
            </b-col>
            <b-col xl="5" lg="5" md="8" sm="12" class="p-0 m-b-15">
              <div class="p-10 rounded bg-light">
                <h3>
                  {{
                    activeScriptItem
                      ? `Edit ${
                          activeScriptItem.confirmed ? 'active' : 'inactive'
                        } item ${activeScriptItem.item.name}`
                      : 'Add new item to active area'
                  }}
                </h3>
                <!-- begin item form -->
                <form>
                  <div
                    class="form-group row m-5 m-b-10 m-t-0"
                    v-if="errors.length"
                  >
                    <p>Please correct the following error(s):</p>
                    <ul>
                      <li
                        v-for="error in errors"
                        :key="error"
                        style="color: red"
                      >
                        {{ error }}
                      </li>
                    </ul>
                  </div>
                  <div class="form-group row m-b-10">
                    <label class="col-form-label col-md-3">{{
                      amountLabel
                    }}</label>
                    <div class="col-md-9">
                      <input
                        v-model="amount"
                        type="number"
                        class="form-control m-b-5"
                        placeholder="Enter amount"
                      />
                    </div>
                  </div>
                  <div class="form-group row m-b-10">
                    <label class="col-form-label col-md-3">{{
                      descriptionLabel
                    }}</label>
                    <div class="col-md-9">
                      <textarea
                        v-model="description"
                        class="form-control"
                        :rows="
                          $route.params.type == 'staff' ||
                          $route.params.type == 'service'
                            ? 2
                            : 3
                        "
                      ></textarea>
                    </div>
                  </div>
                  <div
                    class="form-group row m-b-10"
                    v-if="$route.params.type == 'staff'"
                  >
                    <label class="col-md-3 col-form-label">{{
                      requirementsLabel
                    }}</label>
                    <div class="col-md-9">
                      <textarea
                        v-model="requirements"
                        class="form-control"
                        rows="2"
                      />
                    </div>
                  </div>
                  <div
                    class="form-group row m-b-10"
                    v-if="$route.params.type == 'space'"
                  >
                    <label class="col-md-3 col-form-label"
                      >Set up/down time</label
                    >
                    <div class="col-md-9">
                      <div class="row row-space-10">
                        <div class="col-xs-6">
                          <date-picker
                            v-model="setupStartTime"
                            :config="configs.setupStart"
                            ref="setupStartDate"
                            v-on:dp-change="onSetupStartChange"
                            placeholder="Setup start date and time"
                          ></date-picker>
                        </div>
                        <div class="col-xs-6">
                          <date-picker
                            v-model="setupEndTime"
                            :config="configs.setupEnd"
                            ref="setupEndDate"
                            v-on:dp-change="onSetupEndChange"
                            placeholder="Set down date and time"
                          ></date-picker>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="form-group row m-b-10">
                    <label class="col-md-3 col-form-label">{{
                      timeLabel
                    }}</label>
                    <div class="col-md-9">
                      <div class="row row-space-10">
                        <div class="col-xs-6">
                          <date-picker
                            v-model="startTime"
                            :config="configs.start"
                            ref="startDate"
                            v-on:dp-change="onStartChange"
                            placeholder="Start date and time"
                          ></date-picker>
                        </div>
                        <div class="col-xs-6">
                          <date-picker
                            v-model="endTime"
                            :config="configs.end"
                            ref="endDate"
                            v-on:dp-change="onEndChange"
                            placeholder="End date and time"
                          ></date-picker>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    class="form-group row m-b-10"
                    v-if="$route.params.type == 'service'"
                  >
                    <label class="col-md-3 col-form-label">{{
                      requirementsLabel
                    }}</label>
                    <div class="col-md-9">
                      <textarea
                        v-model="requirements"
                        class="form-control"
                        rows="2"
                      />
                    </div>
                  </div>
                  <div class="form-group row m-b-10">
                    <label class="col-form-label col-md-3"
                      >Cost estimate per item</label
                    >
                    <div class="col-md-9">
                      <input
                        v-model="costEstimate"
                        type="number"
                        class="form-control m-b-5"
                        placeholder="Enter estimated cost"
                      />
                    </div>
                  </div>
                  <div class="form-group row m-b-10">
                    <label class="col-md-3 col-form-label">Remarks</label>
                    <div class="col-md-9">
                      <textarea
                        v-model="remarks"
                        class="form-control"
                        rows="3"
                      />
                    </div>
                  </div>
                </form>
                <!-- end item form -->
                <hr />
                <div class="text-right">
                  <input-button
                    type="button"
                    v-if="activeScriptItem"
                    :label="
                      activeScriptItem && activeScriptItem.confirmed
                        ? 'Move to working area'
                        : 'Move to active area'
                    "
                    @click="confirmScriptItem(activeScriptItem)"
                    class="btn-gray"
                  />
                  <input-button
                    type="button"
                    v-if="activeScriptItem && !activeScriptItem.confirmed"
                    label="Delete"
                    @click="deleteScriptItem(activeScriptItem)"
                    class="btn-danger"
                  />
                  <input-button
                    type="submit"
                    :label="activeScriptItem ? 'Save' : 'Add'"
                    @click="validate"
                    class="btn-yellow"
                  />
                </div>
              </div>
            </b-col>
          </b-row>
          <b-row>
            <b-col
              xl="4"
              lg="4"
              sm="12"
              class="rounded border p-b-15 p-t-5 m-b-15"
            >
              <h3>Working area</h3>
              <div v-if="currentStep && currentStep.workitems">
                <div
                  class="card-columns"
                  v-if="filterStepWorkItems(currentStep).length"
                >
                  <!-- begin scriptitem card -->
                  <div
                    v-for="(wItem, index) in filterStepWorkItems(currentStep)"
                    :key="index"
                    class="card text-white border text-center m-5"
                  >
                    <div
                      class="card-body"
                      :class="
                        (activeItem &&
                          !activeScriptItem &&
                          wItem.id == activeItem.id) ||
                        (activeScriptItem &&
                          activeScriptItem.id == wItem.id &&
                          activeItem &&
                          activeItem.id == wItem.item.id)
                          ? 'bg-dark'
                          : 'bg-light text-dark'
                      "
                    >
                      <blockquote class="blockquote mb-0">
                        <p class="mb-2">
                          {{ wItem.item ? wItem.item.name : wItem.name }}
                          <b-badge
                            v-if="wItem.item"
                            :variant="
                              activeScriptItem &&
                              activeScriptItem.id == wItem.id &&
                              activeItem &&
                              activeItem.id == wItem.item.id
                                ? 'light'
                                : 'dark'
                            "
                            >{{ wItem.amount }}</b-badge
                          >
                        </p>
                        <footer class="text-white-transparent-8">
                          <input-button
                            v-if="
                              (activeItem &&
                                !activeScriptItem &&
                                wItem.id == activeItem.id) ||
                              (activeScriptItem &&
                                activeScriptItem.id == wItem.id &&
                                activeItem.id &&
                                activeItem == wItem.item.id)
                            "
                            type="button"
                            label="Selected"
                            @click="
                              setActiveItem(wItem, wItem.item ? true : false)
                            "
                            class="btn-yellow btn-sm mt-1 w-100"
                            disabled
                          />
                          <input-button
                            v-else
                            type="button"
                            label="Select"
                            @click="
                              setActiveItem(wItem, wItem.item ? true : false)
                            "
                            class="btn-yellow btn-sm mt-1 w-100"
                          />
                        </footer>
                      </blockquote>
                    </div>
                  </div>
                  <!-- end scriptitem card -->
                </div>
                <div v-else>No items in working area.</div>
              </div>
            </b-col>
            <b-col xl="8" lg="8" sm="12" class="p-0 p-l-15">
              <item-table
                :items="items"
                :categories="categories"
                :scriptItems="scriptItems"
                :setActiveItem="setActiveItem"
                :activeItem="activeItem"
                :activeEvent="activeEvent"
                :createItemCall="createBankItemCall"
                :removeImage="removeImage"
                :removeFile="removeFile"
              />
            </b-col>
          </b-row>
        </div>
        <!-- end 4S page content -->
      </b-tabs>
    </b-card>

    <!-- begin active item modal -->
    <b-modal
      ref="modalActiveItem"
      size="xl"
      centered
      title="Selected item"
      class="row"
      hide-footer
    >
      <div class="col-12">
        <div v-if="activeItem">
          <div class="row">
            <div class="col-xl-6">
              <b-card
                class="m-b-20"
                :title="activeItem.name"
                :img-src="getImage(activeItem.image)"
                img-alt="Image"
                img-top
                bg-variant="dark"
                text-variant="light"
              >
                <b-card-text>{{ activeItem.description }} </b-card-text>
              </b-card>
            </div>
            <div class="col-xl-6">
              <b-card
                class="m-b-20"
                header-tag="header"
                header-bg-variant="dark"
                header-text-variant="light"
              >
                <template v-slot:header>
                  <h6 class="mb-0">Details</h6>
                </template>
                <b-card-text>
                  <b>Name: </b><span>{{ activeItem.name }}</span
                  ><br />
                  <b>{{ mainCategoryTitle }}: </b>
                  <span v-if="activeItem.category">{{
                    this.getMainCategory(activeItem.category.parent)
                  }}</span>
                  <span v-else>None</span> <br />
                  <b>{{ subcategoryTitle }}: </b>
                  <span v-if="activeItem.category">{{
                    activeItem.category.name
                  }}</span>
                  <span v-else>None</span> <br />
                  <b>Source: </b>{{ activeItem.source }} <br />
                  <b>Total: </b>{{ activeItem.amount }} {{ activeItem.unit }}
                </b-card-text>
              </b-card>
              <b-card
                class="m-b-20"
                header-tag="header"
                header-bg-variant="dark"
                header-text-variant="light"
              >
                <template v-slot:header>
                  <h6 class="mb-0">Script data</h6>
                </template>
                <b-card-text>
                  <div>
                    <b>Number of active items: </b
                    ><span>{{ activeNumber }}</span
                    ><br />
                    <b>Storyboards where used: </b>
                    <p v-if="!storyboardsWhereUsed.length">None</p>
                    <ul>
                      <li
                        v-for="storyboard in storyboardsWhereUsed"
                        :key="storyboard.id"
                      >
                        {{ storyboard.name }}
                      </li>
                    </ul>
                    <b>Stages where used: </b>
                    <p v-if="!stagesWhereUsed.length">None</p>
                    <ul>
                      <li v-for="stage in stagesWhereUsed" :key="stage.id">
                        {{ stage.name }}
                      </li>
                    </ul>
                    <b>Steps where used: </b>
                    <p v-if="!stepsWhereUsed.length">None</p>
                    <ul>
                      <li v-for="step in stepsWhereUsed" :key="step.id">
                        {{ step.name }}
                      </li>
                    </ul>
                  </div>
                </b-card-text>
              </b-card>
            </div>
          </div>
          <div class="row">
            <div class="col-xl-6">
              <b-card
                class="m-b-20"
                header-tag="header"
                header-bg-variant="dark"
                header-text-variant="light"
              >
                <template v-slot:header>
                  <h6 class="mb-0">Files</h6>
                </template>
                <b-card-text>
                  <vue-custom-scrollbar class="height-sm">
                    <div class="row">
                      <div
                        class="m-20 text-center"
                        v-for="file in activeItem.files"
                        :key="file.id"
                      >
                        <a
                          :href="fileUrl + file.fileFd"
                          :download="file.fileFd"
                        >
                          <i
                            v-if="fileType(file.fileFd) == 'pdf'"
                            class="fas fa-file-pdf fa-5x"
                          />
                          <i
                            v-else-if="
                              fileType(file.fileFd) == ('jpg' || 'jpeg')
                            "
                            class="fas fa-file-image fa-5x"
                          />
                          <p class="text-black">{{ file.name }}</p>
                        </a>
                      </div>
                    </div>
                    <div v-if="!activeItem.files.length">
                      <p class="m-l-10">No files</p>
                    </div>
                  </vue-custom-scrollbar>
                </b-card-text>
              </b-card>
            </div>
            <div class="col-xl-6">
              <b-card
                header-tag="header"
                header-bg-variant="dark"
                header-text-variant="light"
              >
                <template v-slot:header>
                  <h6 class="mb-0">Notes</h6>
                </template>
                <b-card-text>
                  <vue-custom-scrollbar class="height-sm">
                    <ul
                      class="media-list media-list-with-divider media-messaging"
                    >
                      <li
                        class="media media-sm"
                        v-for="(note, index) in activeItem.notes"
                        :key="note.id"
                      >
                        <div class="media-body">
                          <h5 class="media-heading">Note #{{ index + 1 }}</h5>
                          <p>{{ note.content }}</p>
                        </div>
                      </li>
                      <li
                        v-if="!activeItem.notes.length"
                        class="media media-sm"
                      >
                        <div class="media-body">
                          <p>No notes</p>
                        </div>
                      </li>
                    </ul>
                  </vue-custom-scrollbar>
                </b-card-text>
              </b-card>
            </div>
          </div>
        </div>
      </div>
    </b-modal>
    <!-- end active item modal -->
  </div>
</template>

<script>
import InputButton from '../buttons/InputButton.vue'
import ItemTable from '../script/ItemTable.vue'
import ScriptStepSummary from '../script/ScriptStepSummary.vue'
import StepShow from '../storyboard/StepShow.vue'

export default {
  name: 'ScriptContent',
  props: [
    'categories',
    'items',
    'steps',
    'stages',
    'storyboards',
    'item',
    'scriptItems',
    'selectedSteps',
    'activeEvent',
    'createBankItemCall',
    'removeImage',
    'removeFile'
  ],
  components: {
    InputButton,
    ItemTable,
    ScriptStepSummary,
    StepShow
  },
  data() {
    return {
      fileUrl: process.env.VUE_APP_API_URL + '/uploads/files/',
      tabIndex: 0,
      errors: [],
      amount: null,
      description: '',
      startTime: null,
      endTime: null,
      setupStartTime: null,
      setupEndTime: null,
      costEstimate: null,
      requirements: '',
      remarks: '',
      filteredScriptItems: [],
      typeCategories: [],
      stepSlide: 0,
      index: 0,
      currentStep: null,
      currentStepTypeState: null,
      activeScriptItem: null,
      activeItem: null,
      amountLabel: '',
      descriptionLabel: '',
      requirementsLabel: '',
      timeLabel: '',
      mainCategoryTitle: 'Service category',
      subcategoryTitle: 'Service area',
      activeNumber: 0,
      stepsWhereUsed: [],
      stagesWhereUsed: [],
      storyboardsWhereUsed: [],
      // filters
      categoryFilterLabel: 'Venue:',
      subcategoryFilterLabel: 'Area:',
      categoryFilter: 'all',
      subcategoryFilter: 'all',
      source: 'All',
      status: 'all',
      search: '',
      // date input configs
      configs: {
        start: {
          format: 'DD.MM.YYYY HH:mm',
          useCurrent: false,
          showClear: true,
          showClose: true,
          sideBySide: true,
          minDate: false,
          maxDate: false
        },
        end: {
          format: 'DD.MM.YYYY HH:mm',
          useCurrent: false,
          showClear: true,
          showClose: true,
          sideBySide: true,
          minDate: false
        },
        setupStart: {
          format: 'DD.MM.YYYY HH:mm',
          useCurrent: false,
          showClear: true,
          showClose: true,
          sideBySide: true,
          minDate: false,
          maxDate: false
        },
        setupEnd: {
          format: 'DD.MM.YYYY HH:mm',
          useCurrent: false,
          showClear: true,
          showClose: true,
          sideBySide: true,
          minDate: false
        }
      }
    }
  },
  methods: {
    validate() {
      if (this.startTime == null) {
        this.startTime = ''
      }
      if (this.endTime == null) {
        this.endTime = ''
      }
      if (this.setupStartTime == null) {
        this.setupStartTime = ''
      }
      if (this.setupEndTime == null) {
        this.setupEndTime = ''
      }
      if (this.description == null) {
        this.description = ''
      }
      if (this.requirements == null) {
        this.requirements = ''
      }
      if (this.remarks == null) {
        this.remarks = ''
      }
      if (this.costEstimate == null) {
        this.costEstimate = 0
      }

      if (this.amount && this.amount > 0) {
        this.submit()
      }

      this.errors = []

      if (!this.amount || this.amount <= 0) {
        this.errors.push('Amount required!')
      }
      if (!this.activeItem) {
        this.errors.push('Choose an item to add!')
      }
    },
    submit() {
      if (this.currentStep && this.activeItem && this.activeScriptItem) {
        // edit script item
        this.$parent.itemUpdate(
          this.activeScriptItem.id,
          JSON.stringify({
            amount: parseInt(this.amount),
            description: this.description,
            startTime: this.startTime,
            endTime: this.endTime,
            setupStartTime: this.setupStartTime,
            setupEndTime: this.setupEndTime,
            costEstimate: this.costEstimate,
            remarks: this.remarks,
            requirements: this.requirements
          })
        )
      } else if (this.currentStep && this.activeItem) {
        // create script item
        this.$parent.itemCreate(
          JSON.stringify({
            step: parseInt(this.currentStep.id),
            item: parseInt(this.activeItem.id),
            amount: parseInt(this.amount),
            description: this.description,
            startTime: this.startTime,
            endTime: this.endTime,
            setupStartTime: this.setupStartTime ? this.setupStartTime : '',
            setupEndTime: this.setupEndTime ? this.setupEndTime : '',
            remarks: this.remarks,
            costEstimate: this.costEstimate,
            requirements: this.requirements,
            eventId: parseInt(this.activeEvent.id)
          })
        )
        // remove from workitems
        if (this.currentStep.workitems.length) {
          this.removeWorkItem(this.activeItem.id)
        }
        this.emptyActiveItem()
        this.errors = []
      }
    },
    deleteScriptItem(scriptItem) {
      if (confirm(`Are you sure you want to delete ${scriptItem.item.name}?`)) {
        this.$parent.itemDelete(scriptItem.id)
      }
    },
    confirmScriptItem(scriptItem) {
      if (
        confirm(
          `Move ${scriptItem.item.name} ${
            scriptItem.confirmed ? 'to working area' : 'to active area'
          }?`
        )
      ) {
        var state = scriptItem.confirmed
        this.$parent.itemUpdate(
          this.activeScriptItem.id,
          JSON.stringify({
            confirmed: !state
          })
        )
      }
    },
    resetFormValues() {
      this.amount = null
      this.description = ''
      this.startTime = null
      this.endTime = null
      this.setupStartTime = null
      this.setupEndTime = null
      this.costEstimate = null
      this.remarks = ''
      this.requirements = ''
      this.errors = []
    },
    remove(workitem) {
      if (confirm(`Remove workitem ${workitem.name} from current step?`)) {
        this.removeWorkItem(workitem.id)
      }
    },
    removeWorkItem(itemId) {
      var ids = []
      this.currentStep.workitems.forEach((item, index) => {
        if (item.id == itemId) {
          this.currentStep.workitems.splice(index, 1)
        } else {
          ids.push(item.id)
        }
      })
      if (this.currentStep.workitems.length != ids.length) {
        // remove workitem from step
        this.$parent.stepUpdate(
          this.currentStep.id,
          JSON.stringify({
            workitemIds: ids
          })
        )
      }
    },
    stepColumnSize(currentStep) {
      if (currentStep && currentStep.target && currentStep.plan) {
        return 4
      } else if (currentStep && currentStep.target) {
        return 5
      } else if (currentStep && currentStep.plan) {
        return 5
      } else {
        return 10
      }
    },
    navigateTo(typeParam) {
      this.setActiveItems(typeParam)
      if (this.$route.params.type != typeParam) {
        this.$router.push(`/script/${typeParam}`)
      }
      this.resetFilters()
    },
    previousStep() {
      if (this.index == 0) {
        this.index = this.selectedSteps.length - 1
      } else {
        this.index--
      }
      this.showStepById(this.selectedSteps[this.index].id)
    },
    nextStep() {
      if (this.index == this.selectedSteps.length - 1) {
        this.index = 0
      } else {
        this.index++
      }
      this.showStepById(this.selectedSteps[this.index].id)
    },
    toStep(index) {
      this.showStepById(this.selectedSteps[index].id)
    },
    showStepById(stepId) {
      this.selectedSteps.forEach((selectedStep) => {
        if (selectedStep.id == stepId) {
          this.currentStep = selectedStep
        }
      })
      this.filterScriptItems(stepId)
      this.setActiveItems()
      this.resetFilters()
    },
    showStep() {
      this.$refs['modalStep'].show()
    },
    resetFilters() {
      this.search = ''
      this.categoryFilter = 'all'
      this.subcategoryFilter = 'all'
      this.source = 'All'
      this.status = 'all'
      this.applyFilters()
    },
    applyFilters() {
      this.filterScriptItems(this.currentStep.id)
    },
    parentCategories() {
      let matchingCategories = []
      let type = this.$route.params.type
      let typeId = 1
      switch (type) {
        case 'service':
          typeId = 1
          break
        case 'space':
          typeId = 2
          break
        case 'staff':
          typeId = 3
          break
        case 'stuff':
          typeId = 4
          break
        case 'summary':
          typeId = 5
          break
        default:
          typeId = 1
          break
      }
      this.categories.filter(function (category) {
        if (category.type.id == typeId && category.parent == null) {
          matchingCategories.push(category)
        }
      })
      return matchingCategories
    },
    subcategories() {
      let subcategoriesInType = []
      let parentCategory = this.categoryFilter
      if (parentCategory != 'all') {
        this.categories.forEach((category) => {
          if (category.parent) {
            if (category.parent.id == parentCategory) {
              subcategoriesInType.push(category)
            }
          }
        })
      }
      return subcategoriesInType
    },
    getImage(image) {
      if (image == null) {
        return require('../../assets/images/no_image.jpg')
      } else {
        return process.env.VUE_APP_API_URL + '/uploads/images/' + image.imageFd
      }
    },
    filterCategories(typeParam) {
      return this.categories.filter(function (category) {
        return (
          category.type.name.toLowerCase() == typeParam && category.items.length
        )
      })
    },
    filterScriptItems(stepId, typeParam = this.$route.params.type) {
      let typeId = 1
      switch (typeParam) {
        case 'service':
          typeId = 1
          break
        case 'space':
          typeId = 2
          break
        case 'staff':
          typeId = 3
          break
        case 'stuff':
          typeId = 4
          break
        default:
          //typeId = 1;
          break
      }
      var filteredScriptItems = this.scriptItems.filter(function (scriptItem) {
        return (
          scriptItem.step.id == stepId &&
          scriptItem.item.type == typeId &&
          scriptItem.confirmed
        )
      })
      this.filteredScriptItems = filteredScriptItems
    },
    filterStepWorkItems(step, typeParam = this.$route.params.type) {
      let workItems = []
      let typeId = 1
      switch (typeParam) {
        case 'service':
          typeId = 1
          break
        case 'space':
          typeId = 2
          break
        case 'staff':
          typeId = 3
          break
        case 'stuff':
          typeId = 4
          break
        default:
          break
      }
      // current step unconfirmed script items
      this.scriptItems.forEach(function (scriptItem) {
        if (
          scriptItem.step.id == step.id &&
          scriptItem.item.type == typeId &&
          !scriptItem.confirmed
        ) {
          workItems.push(scriptItem)
        }
      })
      // current step work items
      step.workitems.forEach(function (item) {
        if (item.type == typeId) {
          workItems.push(item)
        }
      })
      return workItems
    },
    setActiveItem(item, isScriptItem = false) {
      if (isScriptItem) {
        this.activeScriptItem = item
        this.activeItem = this.getFullItem(item.item.id)
        // set form data
        this.amount = item.amount
        this.description = item.description
        this.startTime = item.startTime
        this.endTime = item.endTime
        this.remarks = item.remarks
        this.costEstimate = item.costEstimate
        this.setupStartTime = item.setupStartTime
        this.setupEndTime = item.setupEndTime
        this.requirements = item.requirements
      } else {
        if (this.activeItem) {
          // set form data
          this.resetFormValues()
        }
        this.activeScriptItem = null
        this.activeItem = this.getFullItem(item.id)
      }
    },
    emptyActiveItem() {
      this.activeScriptItem = null
      this.activeItem = null
      this.resetFormValues()
    },
    getFullItem(itemId) {
      var fullItem
      this.items.forEach((item) => {
        if (item.id == itemId) {
          fullItem = item
        }
      })
      return fullItem
    },
    setActiveItems(typeParam = null) {
      this.activeItem = null
      this.activeScriptItem = null
      // set form data
      this.resetFormValues()
      if (typeParam) {
        this.filterScriptItems(this.currentStep.id, typeParam)
        this.checkTypeState(typeParam)
      } else {
        this.filterScriptItems(this.currentStep.id)
        this.checkTypeState()
      }
    },
    returnToSelection() {
      this.$router.push(`/script`)
    },
    changeStepTypeState() {
      var confirmMsg = this.currentStepTypeState
        ? `Unconfirm ${this.$route.params.type} plans?`
        : `Confirm ${this.$route.params.type} plans?`
      if (confirm(confirmMsg)) {
        var state = !this.currentStepTypeState
        switch (this.$route.params.type) {
          case 'space':
            this.$parent.stepUpdate(
              this.currentStep.id,
              JSON.stringify({
                space: state
              })
            )
            this.currentStep.space = state
            this.currentStepTypeState = state
            break
          case 'stuff':
            this.$parent.stepUpdate(
              this.currentStep.id,
              JSON.stringify({
                stuff: state
              })
            )
            this.currentStep.stuff = state
            this.currentStepTypeState = state
            break
          case 'staff':
            this.$parent.stepUpdate(
              this.currentStep.id,
              JSON.stringify({
                staff: state
              })
            )
            this.currentStep.staff = state
            this.currentStepTypeState = state
            break
          case 'service':
            this.$parent.stepUpdate(
              this.currentStep.id,
              JSON.stringify({
                service: state
              })
            )
            this.currentStep.service = state
            this.currentStepTypeState = state
            break
          default:
            break
        }
      }
    },
    confirmStepPlans(step) {
      if (confirm(`Confirm all plans for step: ${step.name}?`)) {
        this.$parent.stepUpdate(
          this.currentStep.id,
          JSON.stringify({
            space: true,
            stuff: true,
            staff: true,
            service: true
          })
        )
        this.currentStep.space = true
        this.currentStep.stuff = true
        this.currentStep.staff = true
        this.currentStep.service = true
        this.currentStepTypeState = true
      }
    },
    checkTypeState(typeParam = this.$route.params.type) {
      switch (typeParam) {
        case 'space':
          this.currentStepTypeState = this.currentStep.space
          break
        case 'stuff':
          this.currentStepTypeState = this.currentStep.stuff
          break
        case 'staff':
          this.currentStepTypeState = this.currentStep.staff
          break
        case 'service':
          this.currentStepTypeState = this.currentStep.service
          break
        default:
          break
      }
    },
    updateLabels() {
      switch (this.$route.params.type) {
        case 'space':
          this.amountLabel = 'Items required'
          this.descriptionLabel = 'Description'
          this.timeLabel = 'Event time of use'
          break
        case 'stuff':
          this.amountLabel = 'Items required'
          this.descriptionLabel = 'Intended use'
          this.timeLabel = 'Time of use'
          break
        case 'staff':
          this.amountLabel = 'Personnel required'
          this.descriptionLabel = 'Job description'
          this.timeLabel = 'Time active'
          this.requirementsLabel = 'Job requirements'
          break
        case 'service':
          this.amountLabel = 'Providers required'
          this.descriptionLabel = 'Description'
          this.timeLabel = 'Time active'
          this.requirementsLabel = 'Tasks to be done'
          break
        default:
          break
      }
    },
    onStartChange(e) {
      this.$set(this.configs.end, 'minDate', e.date || null)
    },
    onEndChange(e) {
      this.$set(this.configs.start, 'maxDate', e.date || null)
    },
    onSetupStartChange(e) {
      this.$set(this.configs.setupEnd, 'minDate', e.date || null)
    },
    onSetupEndChange(e) {
      this.$set(this.configs.setupStart, 'maxDate', e.date || null)
    },
    checkUsage(currentItemId) {
      let amountInUse = 0
      this.scriptItems.forEach((scriptItem) => {
        if (currentItemId == scriptItem.item.id) {
          amountInUse += scriptItem.amount
        }
      })
      return amountInUse
    },
    getMainCategory(parentCategoryId) {
      let returnValue = 'None'
      this.categories.forEach((category) => {
        if (category.id == parentCategoryId) {
          returnValue = category.name
        }
      })
      return returnValue
    },
    showItem() {
      this.$refs['modalActiveItem'].show()
    },
    getUsage() {
      this.activeNumber = 0
      let stepArray = []
      let stageArray = []
      let storyboardArray = []
      this.scriptItems.forEach((scriptItem) => {
        if (scriptItem.item.id == this.activeItem.id) {
          this.activeNumber += scriptItem.amount
          this.steps.forEach((step) => {
            if (step.id == scriptItem.step.id) {
              stepArray.push(step)
              this.stages.forEach((stage) => {
                if (stage.id == step.stage) {
                  stageArray.push(stage)
                  this.storyboards.forEach((storyboard) => {
                    if (storyboard.id == stage.storyboard) {
                      storyboardArray.push(storyboard)
                    }
                  })
                }
              })
            }
          })
        }
      })
      this.stepsWhereUsed = [...new Set(stepArray)]
      this.stagesWhereUsed = [...new Set(stageArray)]
      this.storyboardsWhereUsed = [...new Set(storyboardArray)]
    }
  },
  watch: {
    $route() {
      this.updateLabels()
      this.errors = []
    },
    activeItem() {
      if (this.activeItem) {
        this.getUsage()
      }
      this.errors = []
    },
    scriptItems() {
      this.filterScriptItems(this.currentStep.id)
    }
  },
  mounted() {
    this.updateLabels()

    // set currentstep, redirect if none selected
    if (this.selectedSteps.length) {
      this.currentStep = this.selectedSteps[0]
      this.setActiveItems()
    } else {
      this.$router.push(`/script`)
    }

    switch (this.$route.params.type) {
      case 'space':
        this.$nextTick(() => {
          this.tabIndex = 0
        })
        if (this.selectedSteps.length) {
          this.currentStepTypeState = this.selectedSteps[0].space
        }
        break
      case 'stuff':
        this.$nextTick(() => {
          this.tabIndex = 1
        })
        if (this.selectedSteps.length) {
          this.currentStepTypeState = this.selectedSteps[0].stuff
        }
        break
      case 'staff':
        this.$nextTick(() => {
          this.tabIndex = 2
        })
        if (this.selectedSteps.length) {
          this.currentStepTypeState = this.selectedSteps[0].staff
        }
        break
      case 'service':
        this.$nextTick(() => {
          this.tabIndex = 3
        })
        if (this.selectedSteps.length) {
          this.currentStepTypeState = this.selectedSteps[0].service
        }
        break
      case 'summary':
        this.$nextTick(() => {
          this.tabIndex = 4
        })
        break
      default:
        break
    }
  }
}
</script>
